// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"common_contentWrapper__1wNr3","richTextContent":"common_richTextContent__1J12Z"};